export class PropertyError {
  constructor(
    readonly propertyPath: string,
    readonly message: string
  ) {}
}
